// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper-module--wrapper--vMVFY","rotation":"Wrapper-module--rotation--1IdLi","pulse":"Wrapper-module--pulse---jmQM"};